<i18n>
{
	"en": {
		"code": "Code",
		"description": "Description",
		"cancelLabel": "Cancel",
		"editTemplate": "Edit Deviation Type Template",
		"newTemplate": "New Deviation Type Template",
		"newTemplateSaved": "Deviation Type Template Saved",
		"save": "Save"
	},
	"no": {
		"code": "Kode",
		"description": "Beskrivelse",
		"cancelLabel": "Avbryt",
		"editTemplate": "Rediger Avvikstype",
		"newTemplate": "Ny Avvikstype",
		"newTemplateSaved": "Avvikstype Lagret",
		"save": "Lagre"
	}
}
</i18n>
<template>
	<t-dialog
		:isShown="showEditDeviationType"
		:title="deviationTypeEditId ? $t('editTemplate') : $t('newTemplate')"
		:confirmLabel="$t('save')"
		:cancelLabel="$t('cancelLabel')"
		:icon="deviationTypeEditId ? 'trip' : 'trip-new'"
		:isConfirmDisabled="!deviationTypeTemplate.code.length"
		width="900px"
		@close="close"
		@ok="save"
	>
		<div class="new-template">
			<t-form-group :title="$t('code')" rowGap="5px" style="grid-column: 1/2;">
				<t-text-input v-model="deviationTypeTemplate.code" />
			</t-form-group>
			<t-form-group :title="$t('description')" rowGap="5px" style="grid-column: 1/2;">
				<t-text-input v-model="deviationTypeTemplate.description" />
			</t-form-group>
		</div>
	</t-dialog>
</template>

<script>
import { mapState, mapActions, mapMutations } from './store/deviations.store.js';

export default {
	name: 'EditDeviationType',
	computed: {
		...mapState([
			'showEditDeviationType',
			'deviationTypeEditId',
			'deviationTypeTemplate',
		])
	},
	methods: {
		...mapActions(['saveDeviationTypeTemplate']),
		...mapMutations(['resetDeviationTypeTemplate']),
		close() {
			this.resetDeviationTypeTemplate();
		},
		async save() {
			return;
			// try {
			// 	await this.saveDeviationTypeTemplate();
			// 	this.$notify({
			// 		type: 'success',
			// 		title: `${this.$t('newTemplateSaved')}: ${this.deviationTypeTemplate.code}`
			// 	});
			// } catch (err) {
			// 	this.$notify({
			// 		type: 'error',
			// 		title: this.$t(err.message),
			// 		duration: -1
			// 	});
			// }
		}
	}
};
</script>


<style lang="scss" scoped>

.new-template {
	display: grid;
	grid-template-columns: repeat(4, minmax(200px, 1fr));
	column-gap: 20px;
	row-gap: 20px;
}

</style>
